import React from 'react';

import { ErrorContainer, ErrorMessageWrapper, ErrorHeader, ErrorText } from './response-error.styled';
import ErrorImage from './error-image';

const FileStorageError = () => {
  return (
    <ErrorMessageWrapper>
      <ErrorContainer>
        <ErrorImage />
        <ErrorHeader>File storage option not supported</ErrorHeader>
        <ErrorText>
          <p>Sorry.</p>
        </ErrorText>
      </ErrorContainer>
    </ErrorMessageWrapper>
  );
};

export default FileStorageError;
